import { render, staticRenderFns } from "./CustomerViewSettlementsTab.vue?vue&type=template&id=71163afb"
import script from "./CustomerViewSettlementsTab.vue?vue&type=script&lang=js"
export * from "./CustomerViewSettlementsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports